import { FC, useCallback, useEffect } from 'react';
import { generatePath, useHistory } from 'react-router';
import Button, { ButtonColor } from '@stripcash/ui-kit/components/Button';
import Modal from '@stripcash/ui-kit/components/Modal';
import sysend from 'sysend';

import { OVERVIEW_NEWS_PATH } from 'common/selectors/sidebar/common';
import { ENTITY_ID } from 'common/routes/constants';

import s from './styles.module.css';
import { READING_LATEST_POST_SYSEND_EVENT } from './constants';

type NewsAlertModalProps = {
  onClose: (id?: number) => void;
  params: {
    id: number;
    subject: string;
    message: string;
  };
};

const NewsAlertModal: FC<NewsAlertModalProps> = ({
  onClose,
  params = { id: 0, subject: '', message: '' },
}) => {
  const history = useHistory();

  const handleSubmit = useCallback(
    (event) => {
      event.preventDefault();
      onClose(params.id);

      history.push(
        generatePath(`${OVERVIEW_NEWS_PATH}${ENTITY_ID}`, {
          id: params.id,
        }),
      );
      sysend.broadcast(READING_LATEST_POST_SYSEND_EVENT);
    },
    [params.id, history, onClose],
  );

  useEffect(() => {
    sysend.on(READING_LATEST_POST_SYSEND_EVENT, onClose);

    return () => {
      sysend.off(READING_LATEST_POST_SYSEND_EVENT, onClose);
    };
  }, [params.id, onClose]);

  return (
    <form className={s.form} onSubmit={handleSubmit}>
      <Modal
        header={params.subject}
        footer={
          <Button type="submit" color={ButtonColor.Blue}>
            Read more
          </Button>
        }
        onClose={onClose}
      >
        <div
          className={s.preview}
          dangerouslySetInnerHTML={{ __html: params.message }}
        />
      </Modal>
    </form>
  );
};

export default NewsAlertModal;
